import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/framework/theme/ThemeProvider.tsx
const makeVariablesResolver = (theme) => {
	if (!theme) return () => ({
		variables: {},
		light: {},
		dark: {}
	});
	const colors = theme.colors ?? {};
	const light = Object.entries(colors).reduce((acc, [name, shades]) => {
		if (shades?.length !== 10) return acc;
		return {
			...acc,
			[`--mantine-color-${name}-background-hover`]: shades[0],
			[`--mantine-color-${name}-background`]: shades[7],
			[`--mantine-color-${name}-foreground`]: shades[2],
			[`--mantine-color-${name}-text`]: shades[6],
			[`--mantine-color-${name}-light`]: `var(--mantine-color-${name}-0)`
		};
	}, {
		["--mantine-color-high-contrast-background"]: "var(--mantine-color-gray-8)",
		["--mantine-color-high-contrast-foreground"]: "var(--mantine-color-white)",
		["--mantine-color-high-contrast-inverted-background"]: "var(--mantine-color-white)",
		["--mantine-color-high-contrast-inverted-foreground"]: "var(--mantine-color-gray-8)"
	});
	const dark = Object.entries(colors).reduce((acc, [name, shades]) => {
		if (shades?.length !== 10) return acc;
		return {
			...acc,
			[`--mantine-color-${name}-background-hover`]: shades[9],
			[`--mantine-color-${name}-background`]: shades[2],
			[`--mantine-color-${name}-foreground`]: shades[7],
			[`--mantine-color-${name}-text`]: shades[2]
		};
	}, {
		["--mantine-color-high-contrast-background"]: "var(--mantine-color-white)",
		["--mantine-color-high-contrast-foreground"]: "var(--mantine-color-gray-8)",
		["--mantine-color-high-contrast-inverted-background"]: "var(--mantine-color-gray-8)",
		["--mantine-color-high-contrast-inverted-foreground"]: "var(--mantine-color-white)"
	});
	const halfSteps = theme.other?.colors?.halfSteps ?? {};
	const variables = Object.entries(halfSteps).reduce((acc, [name, steps]) => {
		Object.entries(steps ?? {}).forEach(([step, value]) => {
			acc[`--mantine-color-${name}-${step}`] = value;
		});
		return acc;
	}, {});
	return () => ({
		variables,
		light,
		dark
	});
};
const ThemeProvider = ({ theme = {}, children, ...restProps }) => {
	const cssVariablesResolver = makeVariablesResolver(theme);
	return /* @__PURE__ */ jsxs(MantineProvider, {
		...restProps,
		theme,
		cssVariablesResolver,
		children: [/* @__PURE__ */ jsx(Notifications, {}), /* @__PURE__ */ jsx(ModalsProvider, { children })]
	});
};

//#endregion
export { ThemeProvider };